import { superElementStyle } from './SuperElement.styles';
import { LitElement, css, type CSSResultGroup } from 'lit';
import { TranslationsTask } from '../../tasks/TranslationsTask';
import type { BaseTranslationsLoader } from '@atlas/shared/universal/i18n/lib/translations-loader.ts';
import { getCurrentCountry, getCurrentLanguage, type AppCountry, type AppLanguage } from '@atlas/shared/universal/i18n';

type TranslationsConfig = {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    translationsLoaderGetter?: () => BaseTranslationsLoader<any>;
    fetchAsyncServerTranslations?: boolean;
};

export abstract class SuperElement extends LitElement {
    static styles = css`
        ${superElementStyle}
    ` as CSSResultGroup;

    country: AppCountry = typeof window !== 'undefined' ? getCurrentCountry(window.location.hostname) : 'fr';
    language: AppLanguage =
        typeof window !== 'undefined'
            ? getCurrentLanguage({ country: this.country, cookies: document.cookie })
            : 'fr-FR';

    protected translationsTask?: TranslationsTask;

    constructor(private translationsConfig: TranslationsConfig = {}) {
        super();
        if (this.translationsConfig.translationsLoaderGetter) {
            this.translationsTask = new TranslationsTask(
                this,
                this.translationsConfig.translationsLoaderGetter,
                {
                    args: () => []
                },
                this.translationsConfig.fetchAsyncServerTranslations
            );
        }
    }

    render() {
        if (this.translationsTask) {
            return this.translationsTask.render({
                complete: () => this.renderElement()
            });
        }
        return this.renderElement();
    }

    protected abstract renderElement(): unknown;
}
